import type { WheelCardConfig } from 'store/modules/brandConfig/types'

export const fallbackWheelCardConfig: WheelCardConfig = {
  translates: {
    headline_claim_alt: 'Congrats, You won!',
    button_claim: 'CLAIM PRIZE',
    error_msg_line1: 'Oops, something went wrong.',
    error_msg_line2: 'Please refresh the page to play the feature.',
    next_spin: 'NEXT SPIN',
  },

  images: {
    congrats: `${process.env.IMG_ORIGIN}/rewards/wow-congrats.jpg`,
    celebration: [
      `${process.env.IMG_ORIGIN}/rewards/wow-coin-1.png`,
      `${process.env.IMG_ORIGIN}/rewards/wow-coin-2.png`,
      `${process.env.IMG_ORIGIN}/rewards/wow-coin-3.png`,
      `${process.env.IMG_ORIGIN}/rewards/wow-coin-4.png`,
    ],
  },

  animationConfig: {
    celebration: {},
  },
}
